import React from 'react';
import PropTypes from 'prop-types';
import {
    Route
} from 'react-router-dom';
import { connect } from 'react-redux';

const redirectFunction = () => {
    /**
     * See if we can even redirect
     * Ignore else because this should never actually run on the server...
     * locale will always match the URL
     * */
    /* istanbul ignore else */
    if (typeof window !== 'undefined') {
        // If it's a supported locale, server will reload with the correct data
        // If it's not a supported locale, server will redirect based on existing logic
        window.location.reload();
    }
};

export function LocaleRoute({ children, computedMatch, locale }) {
    if (locale !== computedMatch.params.locale) {
        return (
            <Route render={redirectFunction} />
        );
    }
    return (
        <Route render={() => (children)} />
    );
}

LocaleRoute.propTypes = {
    children: PropTypes.element,
    locale: PropTypes.string.isRequired,
    computedMatch: PropTypes.shape({
        params: PropTypes.shape({
            locale: PropTypes.string
        })
    }).isRequired
};

LocaleRoute.defaultProps = {
    /**
     * If LocaleRoute and ProtectedRoute are chained, the content is in
     * a render function instead of the children prop.
     * */
    children: null
};

const mapStateToProps = (state) => {
    const { app } = state;
    const { locale } = app;
    return {
        locale: locale.display
    };
};

export default connect(mapStateToProps)(LocaleRoute);
